import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, Table } from '../../common/components';
import { getWarranties } from '../../warranty/services/warranty.service';
import CompanyTabsComponent from './companyTabs.container';

const TABLE_CONFIG = {
  columns: [
    {
      caption: 'Data od',
      dataField: 'dateFrom',
      sort: true,
    },
    {
      caption: 'Data do',
      dataField: 'dateTo',
      sort: true,
    },
    {
      caption: 'Marka',
      dataField: 'car.manufacturer.name',
    },
    {
      caption: 'VIN',
      dataField: 'car.vin',
    },
    {
      caption: 'Nazwa firmy',
      dataField: 'car.company.name',
    },
    {
      caption: 'NIP',
      dataField: 'car.company.vatId',
    },
  ],
  noItemsFoundText: 'Brak gwarancji spelniających kryteria',
  initialSort: {
    sortField: 'createdAt',
    sortDirection: 'desc',
  },
  filterFields: 'car.vin',
};

class CompanyDetailsWarranties extends PureComponent {
  state = {
    data: [],
    totalCount: 0,
    isLoading: true,
  };

  id = this.props.match.params.id;

  getData = async (params) => {
    const {
      match: { params: routeParams },
    } = this.props;

    this.setState({
      isLoading: true,
    });

    const dataTable = await getWarranties(
      Object.assign(params, { 'car.company': routeParams.id }),
    );

    this.setState({
      data: dataTable.data,
      totalCount: dataTable.totalCount,
      isLoading: false,
    });
  };

  onRowClick = (ev) => {
    const { history } = this.props;
    const {
      currentTarget: { id },
    } = ev;

    history.push(`/warranty-details/${id}`);
  };

  render() {
    const { data, isLoading, totalCount } = this.state;

    return (
      <>
        <Breadcrumb title="Lista gwarancji" />
        <div className="content">
          <CompanyTabsComponent active="warranties" />
          <Table
            config={TABLE_CONFIG}
            items={data}
            fetchData={this.getData}
            totalCount={totalCount}
            isLoading={isLoading}
            onRowClick={this.onRowClick}
            pagination
          />
        </div>
      </>
    );
  }
}

CompanyDetailsWarranties.propTypes = {
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(CompanyDetailsWarranties);
